import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule, FormatModule } from '@ctsolution/ct-framework';
import { HandlingItemsDialogComponent } from './handling-items-dialog.component';
import { SharedModule } from 'primeng/api';



@NgModule({
  declarations: [
    HandlingItemsDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,      // Per la mat-table
    TranslateModule,
    CtButtonModule,
    FormatModule
  ],
  exports: [
    HandlingItemsDialogComponent
  ]
})
export class HandlingItemsDialogModule {}
